export default __webpack_public_path__ + "static/media/1219.4207725c.png";